import { UnauthorizedPage } from '@pages/unauthorized/unauthorized.page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/unauthorized')({
  component: UnauthorizedPage,
})
